
import React from 'react';
import { useGA4ViewEvent } from '../../../hooks/useGA4';

const points = [
  {
    icon: 'ri-search-eye-line',
    title: 'あなたに合った求人を厳選提案',
    desc: '膨大な求人データの中から、あなたの経験・希望条件・ライフスタイルにマッチする「隠れた優良求人」を見つけ出し、ご提案します。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '無理な転職は勧めません',
    desc: '表面上の条件だけでなく、あなたの生活や将来を考慮した上で、本当に納得できる職場だけをご紹介。無理な転職は一切勧めません。',
  },
  {
    icon: 'ri-file-edit-line',
    title: '面接・書類作成を徹底フォロー',
    desc: '履歴書・職務経歴書の作成から面接対策まで、経験豊富なアドバイザーがマンツーマンでサポートいたします。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '完全無料でサポート',
    desc: '相談から内定まで、すべてのサポートが完全無料。費用は一切かかりませんので、安心してご利用ください。',
  },
];

export default function SolutionSection() {
  const sectionRef = useGA4ViewEvent('nijikango04_view_solution');

  return (
    <section ref={sectionRef} id="section-solution" className="py-12 px-5 bg-white">
      <h2 className="text-[22px] font-bold text-center text-gray-900 mb-3 leading-[1.5]">
        なぜ、私たちの診断で<br />理想の職場が見つかるのか？
      </h2>
      <p className="text-center text-[13px] text-gray-500 mb-10">
        データとプロの目で最適な働き方を導き出します
      </p>

      <div className="space-y-4">
        {points.map((item, index) => (
          <div
            key={item.title ?? index}
            className="bg-pink-50 rounded-2xl p-6"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-8 h-8 bg-pink-500 rounded-full flex items-center justify-center flex-shrink-0 text-white text-[13px] font-bold">
                {index + 1}
              </div>
              <h3 className="text-[16px] font-bold text-gray-900">
                {item.title}
              </h3>
            </div>
            <p className="text-[13px] text-gray-600 leading-[1.8] pl-11">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
